var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedInBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.94 2.99905C4.93974 3.52948 4.72877 4.03808 4.35351 4.41297C3.97825 4.78785 3.46944 4.99831 2.939 4.99805C2.40857 4.99778 1.89997 4.78681 1.52508 4.41155C1.1502 4.03629 0.939737 3.52748 0.940003 2.99705C0.940268 2.46661 1.15124 1.95801 1.5265 1.58313C1.90176 1.20824 2.41057 0.997782 2.941 0.998047C3.47144 0.998312 3.98004 1.20928 4.35492 1.58454C4.72981 1.9598 4.94027 2.46861 4.94 2.99905ZM5 6.47905H1V18.999H5V6.47905ZM11.32 6.47905H7.34V18.999H11.28V12.429C11.28 8.76905 16.05 8.42905 16.05 12.429V18.999H20V11.069C20 4.89905 12.94 5.12905 11.28 8.15905L11.32 6.47905Z",
    fill: "#22428F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInBlue);
export default __webpack_public_path__ + "static/media/LinkedInBlue.9a12b98b453ca5f8c018e96f6c6682b1.svg";
export { ForwardRef as ReactComponent };